import PropTypes from 'prop-types';

const WarningIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9145 0.808891C21.8564 0.278591 22.9191 0 24 0C25.0809 0 26.1436 0.278591 27.0855 0.808891C28.0274 1.33919 28.8168 2.1033 29.3773 3.02749L29.3834 3.03745L47.1401 32.681L47.1572 32.71C47.7063 33.661 47.9969 34.7392 48 35.8374C48.003 36.9356 47.7185 38.0154 47.1747 38.9695C46.6309 39.9235 45.8467 40.7186 44.9002 41.2755C43.9538 41.8324 42.8779 42.1319 41.7798 42.1439L41.7568 42.1442L6.22017 42.144C5.12205 42.132 4.04624 41.8324 3.09976 41.2755C2.15328 40.7186 1.36912 39.9235 0.825299 38.9695C0.281477 38.0154 -0.00305016 36.9356 2.46596e-05 35.8374C0.0030996 34.7392 0.29367 33.661 0.842825 32.71L0.859855 32.681L18.6166 3.03746L20.4151 4.11474L18.6227 3.02749C19.1832 2.1033 19.9726 1.33919 20.9145 0.808891ZM22.2101 5.19786L4.46688 34.8187C4.28831 35.1328 4.19389 35.4877 4.19287 35.8491C4.19185 36.2152 4.28669 36.5751 4.46796 36.8932C4.64924 37.2112 4.91063 37.4762 5.22612 37.6618C5.53885 37.8459 5.89394 37.9455 6.25663 37.9512H41.7434C42.1061 37.9455 42.4611 37.8459 42.7739 37.6618C43.0894 37.4762 43.3508 37.2112 43.532 36.8932C43.7133 36.5751 43.8081 36.2152 43.8071 35.8491C43.8061 35.4878 43.7117 35.1329 43.5332 34.8189L25.7925 5.20203L25.7899 5.19786C25.6032 4.89166 25.3411 4.63846 25.0285 4.4625C24.7145 4.28573 24.3603 4.19286 24 4.19286C23.6397 4.19286 23.2855 4.28573 22.9715 4.4625C22.6589 4.63846 22.3968 4.89166 22.2101 5.19786Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 12.794C25.1578 12.794 26.0964 13.7326 26.0964 14.8904V23.2762C26.0964 24.434 25.1578 25.3726 24 25.3726C22.8422 25.3726 21.9036 24.434 21.9036 23.2762V14.8904C21.9036 13.7326 22.8422 12.794 24 12.794Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9036 31.6619C21.9036 30.5041 22.8422 29.5655 24 29.5655H24.021C25.1788 29.5655 26.1174 30.5041 26.1174 31.6619C26.1174 32.8197 25.1788 33.7583 24.021 33.7583H24C22.8422 33.7583 21.9036 32.8197 21.9036 31.6619Z"
        fill={fill}
      />
    </svg>
  </div>
);

WarningIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

WarningIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default WarningIcon;
